import { type UseQueryResult, useQuery } from 'react-query';
import { RolePublishService } from '@wealthlane/api-services/wealthlane-customer-service';

const useGetPublishedCompaniesByRole = (
  handleRequest: <T>(request: Promise<T>) => Promise<T | undefined>,
  roleId: string
): UseQueryResult<string[] | undefined, unknown> => {
  return useQuery(
    ['getPublishedCompaniesByRole', roleId],
    async () => {
      return await handleRequest(
        RolePublishService.getApiCustomerApiV2CustomerCustomerSuccessRolesPublished(
          undefined,
          roleId,
          undefined,
          undefined,
          0,
          1000
        )
      );
    },
    {
      enabled: !!roleId,
      select: (data) => {
        // Extract destination company IDs from the grouped response
        const destinationCompanyIds: string[] = [];
        data?.items?.forEach((group) => {
          if (group.publishedRoles) {
            group.publishedRoles.forEach((publishedRole) => {
              if (publishedRole.destinationCompanyId) {
                destinationCompanyIds.push(publishedRole.destinationCompanyId);
              }
            });
          }
        });
        return destinationCompanyIds;
      },
    }
  );
};

export default useGetPublishedCompaniesByRole;
